/*
 * @Author: gaomiao 
 * @Date: 2020-04-10 14:24:13 
 * @Last Modified by:   gaomiao 
 * @Last Modified time: 2020-04-10 14:24:13 
 */
const actionTypes = {
  CHANGE_PAGE: 'CHANGE_PAGE',
  //分页
  CHANGE_READFLAG: 'CHANGE_READFLAG'
};
export default actionTypes;